<template>
  <div>
    <!-- Dynamically render the form component based on the note type -->
    <component v-if="userFetched && formComponent" :is="formComponent" :noteDetails="noteDetails" :assignations="assignations"
     :username="username" :user_id="user_id" :transactions="transactions" :notes="notes_in_invoice" :idents="note_idents" ></component>
  </div>
</template>

<style>
.custom-loader {
  position: fixed;
  margin-left: 25vw;
  width: 50vw;
  height: 5vh;
  border-radius: 20px;
  color: #F4BF00;
  border: 2px solid;
}
.custom-loader::before {
  content: "";
  position: absolute;
  margin: 2px;
  inset: 0 100% 0 0;
  border-radius: inherit;
  background: #F4BF00;
  animation: p6 2s infinite;
}
.text-loading-edit-note{
  margin-top: 40vh;
  font-size: 2em;
}

@keyframes p6 {
  100% {
    inset: 0
  }
}
</style>

<script>
import axios from 'axios';
import EditAssistanceNoteInvoice from './EditAssistanceNoteInvoice.vue'; // Example of a form component for a specific type
import EditAuxiliarNoteInvoice from './EditAuxiliarNoteInvoice.vue';
import EditForkliftNoteInvoice from './EditForkliftNoteInvoice.vue';
import EditIndustrialNoteInvoice from './EditIndustrialNoteInvoice.vue';
import EditLotNoteInvoice from './EditLotNoteInvoice.vue';
import EditGroupInvoice from './EditGroupInvoice.vue';
// Import other form components

export default {
  components: {
    EditAssistanceNoteInvoice,
    EditAuxiliarNoteInvoice,
    EditForkliftNoteInvoice,
    EditIndustrialNoteInvoice,
    EditLotNoteInvoice,
    EditGroupInvoice
    // Register other form components here
  },
  data() {
    return {
      noteDetails: null, // Will hold the fetched note details
      noteType: '', // To dynamically determine which form to use
      assignations: [],
      transactions: [],
      username : '',
      user_id : null,
      userFetched: false, // Indicates if the current user has been fetched
      notes_in_invoice: [], // which notes compose the invoice in the case of grouped invoices
      note_idents: [],
    };
  },
  computed: {
    formComponent() {
      // Determine which component to render based on the note type
      const noteNumber = this.$route.params.noteNumber;

      if (noteNumber == 'VARIAS'){
        return 'EditGroupInvoice';
      }

      switch (this.noteType) {
        case 1:
          return 'EditAuxiliarNoteInvoice';
        case 2:
          return 'EditAssistanceNoteInvoice';
        case 3:
          return 'EditForkliftNoteInvoice';
        case 5:
          return 'EditIndustrialNoteInvoice';
        case 4:
          return 'EditLotNoteInvoice';
        // case for other types...
        default:
          return null; // or a default form component if you have one
      }
    },
  },
  async mounted() {
    await this.fetchNoteDetails();
    await this.fetchAssignations();
    await this.fetchCurrentUser();
    await this.fetchTransactions();
    await this.fetchNotes();
  },
  methods: {
    async fetchNoteDetails() {
      const noteID = this.$route.params.noteID; // Get noteID from route params
      console.log(noteID,'this is the note id i got and will determine the endpoint i call')
      // Determine which endpoint to call based on the route params
      if (noteID.includes("FAIL")){
        try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/forklift-notes/` + noteID + "/");
        this.noteDetails = response.data;
        this.noteType = 3; // Assuming the response includes a type field
      } catch (error) {
        console.error("Failed to fetch note details:", error);
      }
      }
      else{
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/notes/` + noteID + "/");
        this.noteDetails = response.data;
        this.noteType = response.data.type; // Assuming the response includes a type field
      } catch (error) {
        console.error("Failed to fetch note details:", error);
        // Handle error (e.g., show user feedback)
      }
    }
    },
      async fetchAssignations() {
        const noteID = this.$route.params.noteID; // Get noteID from route params
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.post(`${apiDirectory}/get-note-assignations`, { "note_ident": noteID });
          this.assignations = response.data;
          //console.log("assignations are", this.assignations)
        }
        catch (error) {
          console.error("Failed to fetch assignations:", error);
        }
      },
      async fetchTransactions() {
        const noteID = this.$route.params.invoiceID; // Get noteID from route params
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.post(`${apiDirectory}/get-invoice-transactions`, { "invoice_ident": noteID });
          this.transactions = response.data;
          //console.log("assignations are", this.assignations)
        }
        catch (error) {
          console.error("Failed to fetch assignations:", error);
        }
      },
      async fetchNotes() {
  const noteID = this.$route.params.invoiceID; // Get noteID from route params
  try {
    const apiDirectory = process.env.API_DIRECTORY;
    const response = await axios.post(`${apiDirectory}/get-invoice-notes-list`, { "invoice_id": noteID });

    // Extract note numbers and note idents from the response
    this.notes_in_invoice = Object.keys(response.data);
    this.note_idents = Object.values(response.data);

    // Debugging logs (optional)
    // console.log("Note numbers are", this.note_numbers);
    // console.log("Note idents are", this.note_idents);
  } catch (error) {
    console.error("Failed to fetch notes:", error);
  }
},

    fetchCurrentUser() {
      /** Fetches the current user data, used to fill in who is making an assignation */
      const apiDirectory = process.env.API_DIRECTORY;
      axios.get(`${apiDirectory}/current-user/`, {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('authToken')
        }
      })
        .then(response => {
          //this.username = response.data.username;
          //this.firstName = response.data.first_name;
          //this.lastName = response.data.last_name;
          //this.groups = response.data.groups;
          this.user_id = response.data.id;
          this.userFetched = true; // Set userFetched to true once user data is fetched
        })
        .catch(error => {
          console.error('There was an error fetching the user data:', error);
        });
    },

  },

};
</script>
